import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth/useAuth";
import type { Permission } from "@/lib/powtoon-be/types";

export function RequirePermission({
  permission,
  children,
}: {
  permission: Permission;
  children: ReactNode;
}) {
  const { isLoading, hasPermission, user } = useAuth();
  if (isLoading) {
    return <div className="p-8 text-sm text-muted-foreground">Loading…</div>;
  }
  if (!user) {
    return (
      <div className="p-8 max-w-md mx-auto text-center space-y-3">
        <h1 className="text-xl font-semibold">Sign in required</h1>
        <p className="text-sm text-muted-foreground">
          You need a Powtoon account to access Live Avatars.
        </p>
      </div>
    );
  }
  if (!hasPermission(permission)) {
    return (
      <div className="p-8 max-w-md mx-auto text-center space-y-3">
        <h1 className="text-xl font-semibold">Access required</h1>
        <p className="text-sm text-muted-foreground">
          Your account does not have the <code>{permission}</code> permission.
        </p>
        <Link to="/" className="text-primary underline text-sm">Back to start</Link>
      </div>
    );
  }
  return <>{children}</>;
}
